export default __webpack_public_path__ + "static/media/trans.11102beb.jpeg";